<template>
  <modal
    name="roulette-result"
    @before-open="beforeOpen"
    @before-close="beforeClose"
    :classes="[
      'v--modal',
      'error-modal',
      'roulette-result',
      hasBugs && 'has-bugs',
    ]"
    :width="730"
    :height="'auto'"
    :adaptive="true"
  >
    <div v-if="result.winner" class="modal-title">Поздравляем!</div>
    <div v-else class="modal-title">Ставка не сыграла</div>
    <div class="modal-close" @click="close"></div>
    <div class="modal-body">
      <div v-if="result.winner" class="modal-subtitle">
        Вы
        <span v-if="result.winner_count > 1">
          и еще
          {{ result.winner_count - 1 }}
          {{
            declineNouns(result.winner_count - 1, [
              "человек",
              "человека",
              "человек",
            ])
          }}
        </span>
        выиграли на ставке
        <span class="bet">{{ result.winning_number }}</span>
      </div>
      <div v-else class="modal-subtitle">
        {{ declineNouns(myBets.length, ["Ваша", "Ваши", "Ваши"]) }}
        {{ declineNouns(myBets.length, ["ставка", "ставки", "ставки"]) }} на
        <span v-for="(bet, index) in myBets" class="bet" :key="index">
          {{ bet }}<span v-if="index == myBets.length - 2"> и </span
          ><span v-if="index == myBets.length - 3">, </span>
        </span>
        {{
          declineNouns(myBets.length, [
            "не сыграла",
            "не сыграли",
            "не сыграли",
          ])
        }}
      </div>
      <img
        v-if="result.prize"
        :src="result.prize.image"
        :alt="result.prize.name"
        class="modal-image"
      />
      <div v-if="result.prize" class="roulette-result-main win">
        Вы получаете приз <span class="prize">{{ result.prize.name }}</span>
      </div>
      <div v-else class="roulette-result-main">
        Выигрышная ставка: <span class="bet">{{ result.winning_number }}</span>
        <br /><br />
        <div v-if="result.winner_count > 0">
          {{
            declineNouns(result.winner_count, [
              "Выиграл",
              "Выиграли",
              "Выиграли",
            ])
          }}
          {{ result.winner_count }}
          {{
            declineNouns(result.winner_count, [
              "человек",
              "человека",
              "человек",
            ])
          }}, с выигрышем
          <span v-if="result.winner_count > 1">по</span>
          <span class="prize">
            {{ result.prize }}
          </span>
        </div>
        <div v-else>Победителей нет</div>
      </div>
      <div class="buttons-row">
        <button @click="close" class="button">ОК</button>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapGetters } from "vuex";
import { declineNouns } from "@/mixins/declineNouns";
import { checkScroll } from "@/mixins/checkScroll";

export default {
  name: "RouletteResult",
  mixins: [declineNouns, checkScroll],
  data() {
    return {
      hasBugs: false,
      myBets: [],
      result: {},
    };
  },
  computed: {
    ...mapGetters({
      user: "user/fetchUser",
      roulette: "roulette/fetchRoulette",
    }),
  },
  methods: {
    beforeOpen(event) {
      this.checkScroll();
      this.result = event.params.data;
      this.myBets = [];
      let bets = this.roulette;
      for (let bet in bets) {
        if (bets[bet].user.id == this.user.id) {
          this.myBets.push(bets[bet].number);
        }
      }
    },
    beforeClose() {
      this.checkRemoveScroll();
    },
    close() {
      this.$modal.hide("roulette-result");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/layout/_roulette";
.error-modal {
  transition: box-shadow 1s;
  &.has-bugs {
    box-shadow: 0 24px 80px -2px rgba(255, 0, 0, 0.4) !important;
  }
}
</style>
